<div class="outer-drag-container" id="outer-drag-container-{{id}}">
  <div id="drag-container-{{id}}"></div>
</div>
<!-- <div id="container"></div> -->
